module.exports = __webpack_public_path__ + "img/a335e8c.jpg";